import { h } from 'preact';
import clsx from 'clsx';
import BlockContent from './BlockContent';
import { Background, Overlay } from './MediaLayers';
import { ALIGN, normalizeAlign } from './constants';

// One 50/50 side. Media layers fill the cell behind an in-flow content column, so
// h-full lets the row's flex stretch give both sides equal height.
const ContentBlock = ({ side, sectionIndex }) => {
  const fetchpriority = sectionIndex === 1 ? 'high' : 'auto';
  const decoding = sectionIndex === 1 ? 'async' : 'auto';
  const loading = sectionIndex === 1 ? 'eager' : 'lazy';

  const xD = normalizeAlign(side.align_x_desktop);
  const yD = normalizeAlign(side.align_y_desktop);
  const xM = normalizeAlign(side.align_x_mobile, xD);
  const yM = normalizeAlign(side.align_y_mobile, yD);

  return (
    <div
      className={clsx(
        'relative flex flex-col h-full w-full overflow-hidden',
        'px-5 py-[47px] laptop:px-10 laptop:py-[60px]',
        ALIGN.justifyM[yM],
        ALIGN.justifyD[yD],
        ALIGN.itemsM[xM],
        ALIGN.itemsD[xD],
        side.hide_on_mobile && 'hidden laptop:flex',
      )}
      style={{ backgroundColor: side.bg_color || undefined }}
    >
      <Background
        side={side}
        fetchpriority={fetchpriority}
        decoding={decoding}
        loading={loading}
      />
      <Overlay side={side} />
      <BlockContent side={side} alignXDesktop={xD} alignXMobile={xM} />
    </div>
  );
};

export default ContentBlock;
